import { render, staticRenderFns } from "./RentPeriodSelectionCard.vue?vue&type=template&id=48253f48&scoped=true"
import script from "./RentPeriodSelectionCard.vue?vue&type=script&lang=js"
export * from "./RentPeriodSelectionCard.vue?vue&type=script&lang=js"
import style0 from "./RentPeriodSelectionCard.vue?vue&type=style&index=0&id=48253f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48253f48",
  null
  
)

export default component.exports